//全局js
import Vue from 'vue';
import { mapState, mapGetters, mapMutations } from "vuex";
import axios from 'axios';
import store from '../store/index';

Object.assign(Vue.prototype, {
	static: 'static/',
	ajaxGet(obj) {
		axios({
			method: 'post',
			responseType: 'blob',
			data: obj.data,
			headers: {
				token: obj.token
			},
			url: parameters.domain + obj.url
		}).then(obj.success);
	},
	ajaxPostWX(obj) {
		// this.$store.commit('SET_LOADING',"yes");
		var that = this;
		this.$Loading.start();
		axios({
			method: 'post',
			url: parameters.domain + obj.url,
			data: obj.data,
			headers: {
				token: obj.token
			}
		}).then(
			function(res) {
				that.$Loading.finish();
				switch (res.data.code) {
					case '0004':
						that.$Notice.open({
							title: res.data.message
						})
						that.$store.commit('SET_LOADING',"no");
						break;
					case '0005':
						that.$Notice.open({
							title: res.data.message
						})
						that.$store.commit('SET_LOADING',"no");
						break;
					default:
						obj.success(res);
						that.$store.commit('SET_LOADING',"no");
						break;
				}
			}

		).catch(function (error) {
    // console.log(error);
    // alert(JSON.stringify(error))
  });
	},
	ajaxPost(obj) {
		var that = this;
		this.$Loading.start();
		axios({
			method: 'post',
			url: parameters.domain + obj.url,
			data: obj.data,
			headers: {
				token: obj.token
			}
		}).then(
			function(res) {
				that.$Loading.finish();
				switch (res.data.code) {
					case '0004':
						if (!that.$store.state.isNoticeLogin) {
							that.$store.state.isNoticeLogin = true;
							that.$Notice.open({
								title: res.data.message + ',请重新登录',
								onClose: function() {
									that.$store.state.isNoticeLogin = false;

								}
							});
							that.$router.push('/login');
						}
						break;
					case '0005':
						that.$Notice.open({
							title: res.data.message
						})
						break;
					default:
						obj.success(res);
						break;
				}
			}

		).catch(function(res) {
			that.$store.state.isLoadingShow = false;
		});
	},
  waterAjaxPost(obj) {
    axios({
      method: 'post',
      url: "http://202.105.25.138:20465" + obj.url + "?system_id=1000000'",
      data: obj.data,
      headers: {
        token: '12345678'
      }
    }).then((res) => {
      let data = res.data;
      if(data.code === "0000") {
        obj.success(data.result);
      }else if(data.code === "0001") {
        this.returnLogin();
      }else {
        obj.error(data);
      }
    }).catch((res) => {
      this.errorWarn("操作失败",res.message);
    });
  },
	/*设置本地存储数据*/
	setKey: function(key, val) {
		if(this.getKey(key)) {
			window.localStorage.removeItem(key);
		}
		window.localStorage.setItem(key, val);
	},
	/*删除本地存储数据*/
	removeKey: function(key) {
		window.localStorage.removeItem(key);
	},
	/*取本地存储数据*/
	getKey: function(key) {
		if(window.localStorage) {
			return window.localStorage.getItem(key);
		}
	},
	/*获取地址栏查询参数的值*/
    getParameter: function(key) {
	    var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
	    var r = decodeURI(window.location.search).substr(1).match(reg);
	    if (r != null) alert(unescape(r[2]));
	    alert(111111);
	},
	//获取表格的宽度 高度
	getTableSize: function(parent, siblings, tableSize) {
		/*
		* parent:    上一级元素 如 '.water-electric-card'
		* siblings:  同级元素 如 ['.ivu-card-head', '.btnArea']
		* tableSize: 存放表格宽高的字段 如 'rainTableSize'
		* rainTableSize: {
		*	width: 100,
		*	height: 100
		* }
		*/
		var that = this;
		// 解决innerWidth()计算不准确
		setTimeout(function() {
			that[tableSize].height = $(parent).innerHeight();
			for (var i in siblings) {
				that[tableSize].height -= $(parent).find(siblings[i]).outerHeight();
			}
			that[tableSize].width = $(parent).innerWidth();
		},50);
	}
});

Object.assign(Date.prototype, {
	format(format) {
		var o = {
			'M+': this.getMonth() + 1, //month
			'd+': this.getDate(), //day
			'h+': this.getHours(), //hour
			'm+': this.getMinutes(), //minute
			's+': this.getSeconds(), //second
			'q+': Math.floor((this.getMonth() + 3) / 3), //quarter
			'S': this.getMilliseconds() //millisecond
		}

		if(/(y+)/.test(format)) {
			format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
		}

		for(var k in o) {
			if(new RegExp('(' + k + ')').test(format)) {
				format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
			}
		}
		return format;
	}
});

Object.assign(Array.prototype,{
	//从数组中删除指定值元素
	removeByValue:function (val) {
			for(var i = 0;i<this.length;i++){
					if(this[i] == val){
							this.splice(i,1);
							break;
					}
			}
	}
})





// WEBPACK FOOTER //
// ./src/global/initProject.js